import { ChangeDetectionStrategy, Component, effect, inject, input, output } from '@angular/core';
import { TooltipDirective } from '@ps-gui/shared-core';

@Component({
  selector: 'shared-ui-removable-tag',
  imports: [],
  templateUrl: './removable-tag.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [TooltipDirective],
  host: {
    class:
      'inline-flex max-w-[18rem] min-w-0 items-center gap-1 rounded-full bg-sky-100 px-2.5 py-1 text-xs text-sky-900',
  },
})
export class RemovableTagComponent {
  readonly label = input.required<string>();
  readonly removeAriaLabel = input.required<string>();

  readonly removed = output<void>();

  private readonly tooltip = inject(TooltipDirective);

  constructor() {
    // The tooltip shows the full label once it is truncated, so it always mirrors the label.
    effect(() => this.tooltip.tooltip.set(this.label()));
  }
}
